import React, { useState } from 'react';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';

import { SpecialSituation, SpecialSituationsService } from 'us-web-services';
import DisplayService from '../../util/DisplayService';
import PageStyles from '../../styles/PageStyles';

function SpecialSituationsAdd(props: RouteComponentProps) {
  const { history } = props;
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { classes } = PageStyles();

  const addSpecialSituation = async () => {
    if (!name.trim()) {
      toast.error('Name is required');

      return;
    }

    setIsSubmitting(true);

    const situationData: SpecialSituation = {
      name: name.trim(),
      disabled: null,
    };

    try {
      await SpecialSituationsService.create(situationData);
      toast.success('Special situation successfully added');
      history.push('/special-situations');
    } catch (error) {
      const displayedError = DisplayService.getErrorResponse(
        error,
        'There was an error adding the special situation.',
      );

      toast.error(displayedError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancel = () => {
    history.push('/special-situations');
  };

  const updateName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && !isSubmitting) {
      addSpecialSituation();
    }
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant='h5' gutterBottom>
        Add Special Situation
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            id='special-situation-name'
            label='Name'
            variant='outlined'
            fullWidth
            required
            value={name}
            onChange={updateName}
            onKeyPress={handleKeyPress}
            helperText='The display name for this special situation (e.g., "Children with Autism Spectrum Disorder")'
            error={!name.trim() && name.length > 0}
          />
        </Grid>
      </Grid>
      <div className={classes.buttons} style={{ marginTop: 20 }}>
        <Button
          id='cancel'
          variant='contained'
          color='secondary'
          onClick={cancel}
          disabled={isSubmitting}
          style={{ marginRight: 10 }}
        >
          Cancel
        </Button>
        <Button
          id='add-special-situation-button'
          variant='contained'
          color='primary'
          onClick={addSpecialSituation}
          disabled={isSubmitting || !name.trim()}
        >
          {isSubmitting ? 'Adding...' : 'Add Special Situation'}
        </Button>
      </div>
    </Paper>
  );
}

export default withRouter(SpecialSituationsAdd);
